import React from "react";
import locales from "@translations/locales";
import ExternalLink from "@components/ExternalLink/externalLink";

const LocalizedExternalLink = ({ url, path, locale, children, title, className }) => {
  const to = locales[locale].default
    ? `${url}${path}`
    : `${url}/${locale}${path}`;

  return (
    <ExternalLink href={to} title={title} className={className}>
      {children}
    </ExternalLink>
  );
};

export default LocalizedExternalLink;
